import utils from './utils';
import wsUtils from './wsUtils';
let closeHandlerEvent;
let iFrameState = 0;
const setiFrameState = (state) => {
    iFrameState = state;
}
const handleSpreadActions = () =>{
    utils.scrollDownEnd(undefined, 0);
    setiFrameState(1);
    wsUtils.startProcess("sendMsgH", {message: {msgtype: 'open_chat'}});
}
const init = () => {
    window.addEventListener('message', function(event) {
        // console.log('message lister:  ' + event.data,event);
        closeHandlerEvent = event;
        var data = event.data;
        switch (data.type) {
            case 'ping': {
                closeHandlerEvent.source.postMessage({type: 'pong'}, closeHandlerEvent.origin);
                break;
            }
            case 'spread': {
                if (!window.requestHis) {
                    requestMessageList("", (res) => {
                      if (res == 1) {
                        handleSpreadActions();
                      }
                    });
                } else {
                    handleSpreadActions();
                }
                break;
            }
        }
        bindHideChatButton();
    }, false);

    // 延迟绑定 onclick 事件处理函数
    function bindHideChatButton() {
        const btnHideChat = document.getElementById('btn-hide-chat');
        if (btnHideChat && closeHandlerEvent) {
            btnHideChat.onclick = function () {
                closeHandlerEvent.source.postMessage({type: 'hidePanel'}, closeHandlerEvent.origin);
                setiFrameState(0);
            };
        } else {
            setTimeout(bindHideChatButton, 100); // 每100毫秒检查一次
        }
    }
};
const postMessage = (message, retryCount = 0) => {
    if (!closeHandlerEvent) {
        retryCount-- > 0 && setTimeout(() => {
            postMessage(message, retryCount);
        }, 100);
        return;
    }
    closeHandlerEvent.source.postMessage(message, closeHandlerEvent.origin);
}

export default{
    getifameState: () => iFrameState,
    setiFrameState,
    init,
    postMessage,
}


// WEBPACK FOOTER //
// ./src/js/shelltool.js